export function App() {
  return (
    <main className="app">
      <h1>@crv-boilerplate/web</h1>
    </main>
  )
}

export default App
